import * as React from 'react'
import OfferPageDispatchContext from './offerPageDispatchContext'
import OfferPageStateContext from './offerPageStateContext'
import type { OfferPageDispatchAction, OfferPageState } from './offerPageStateReducer'
import ModalProvider from 'contexts/ModalProvider'
import { useReportContextToDevPanel } from 'components/App/DevPanel/hooks'

interface Props {
  state: OfferPageState
  dispatch: React.Dispatch<OfferPageDispatchAction>
  children: React.ReactNode
}

export function OfferPageStateProvider(props: Props) {
  useReportContextToDevPanel('OfferPageStateContext', props.state)

  return <OfferPageStateContext.Provider value={props.state}>
    <OfferPageDispatchContext.Provider value={props.dispatch}>
      {/*
        Nested ModalProviders were added in #21501 for offer-page modal history/stacking, but they only
        work when callers use different layers explicitly. useContext(ModalContext) always
        resolves to the inner provider, so multiple showModal calls still share one queue.
        Parent modals (e.g. booking filters, fullscreen map) therefore use ModalBase isOpen
        instead of showModal; child modals continue to use the inner showModal.
      */}
      <ModalProvider>
        <ModalProvider>
          {props.children}
        </ModalProvider>
      </ModalProvider>
    </OfferPageDispatchContext.Provider>
  </OfferPageStateContext.Provider>
}

export default OfferPageStateProvider
